import { getProPageHeaders } from "@similarweb/pro-logic-components";

const engagementEndpoint = "/api/userdata/engagements";

const getAll = async (): Promise<Record<string, unknown>> => {
    try {
        const response = await fetch(`${engagementEndpoint}/`, {
            credentials: "include",
            headers: getProPageHeaders(),
        });
        if (!response.ok) {
            return {};
        }
        return await response.json();
    } catch (_ex) {
        return {};
    }
};

const getShowUpdates = async (): Promise<Record<string, unknown>> => {
    try {
        const response = await fetch(`${engagementEndpoint}/pu`, {
            credentials: "include",
            headers: getProPageHeaders(),
        });
        if (!response.ok) {
            return {};
        }
        return await response.json();
    } catch (_ex) {
        return {};
    }
};

const logEngagement = async (params: Record<string, string | number>): Promise<Response | Record<string, never>> => {
    try {
        const paramsString = Object.entries(params).reduce((prev, [key, value]) => {
            return `${prev}&${key}=${value}`;
        }, "");
        return await fetch(`${engagementEndpoint}/add?${paramsString}`, {
            headers: getProPageHeaders(),
        });
    } catch (_ex) {
        return {};
    }
};

export default {
    logEngagement,
    getShowUpdates,
    getAll,
};
